import { Base } from "../../framework/base";

export interface IRiskClassificationNode {
    id: string;
    parentId: string;
    companyId: string;
    code: string;
    comment: string;
    activeState: number;
    sortOrder: number;
    parent: IRiskClassificationNode;
    children: IRiskClassificationNode[];

    collapsed: boolean;

    isActive(): boolean;
//     isSelectableForNew(): boolean;
    getAncesterIsCollapsed(): boolean;
    getRiskClassificationNodeById(id: string): IRiskClassificationNode;
    getAsList(list: IRiskClassificationNode[]): IRiskClassificationNode[];
//     getAsIdTitleNode(): IIdTitleNode;
}

export class RiskClassificationNode implements IRiskClassificationNode {
    id: string;
    parentId: string;
    companyId: string;
    code: string;
    comment: string;
    activeState: number;
    sortOrder: number;
    parent: RiskClassificationNode;
    children: RiskClassificationNode[];

    collapsed: boolean;

    constructor();
    constructor(obj: IRiskClassificationNode);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.parentId = obj && obj.parentId || "";
        this.companyId = obj && obj.companyId || "";
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.activeState = obj && obj.activeState || 0;
        this.sortOrder = obj && obj.sortOrder || 0;
        this.parent = null;
        if (obj && obj.children) {
            this.children = Base.getTypedArray(obj.children, RiskClassificationNode);
            for (const child of this.children) {
                child.parent = this;
            }
        }
        this.collapsed = obj && obj.collapsed || false;
    }

    isActive(): boolean {
        let result = this.activeState > 0.5;
        if (this.parent) {
            result = result && this.parent.isActive();
        }
        return result;
    }

    // isSelectableForNew(): boolean {
    //     let result = this.eventTypeUsageType === EventTypeUsageType.SelectForNew;
    //     if (this.parent) {
    //         result = result && this.parent.isSelectableForNew();
    //     }
    //     return result;
    // }

    getAncesterIsCollapsed(): boolean {
        if (!this.parent) return false;
        if (this.parent.collapsed) return true;
        return this.parent.getAncesterIsCollapsed();
    }

    getRiskClassificationNodeById(id: string): IRiskClassificationNode {
        if (!id) return null;
        if (this.id.equalIgnoreCase(id)) return this;
        for (const child of this.children) {
            const childResult = child.getRiskClassificationNodeById(id);
            if (childResult) return childResult;
        }
        return null;
    }

    static getRiskClassificationNodeById(nodes: IRiskClassificationNode[], id: string): IRiskClassificationNode {
        if (!id || nodes.length < 1) return null;
        for (const node of nodes) {
            const result = node.getRiskClassificationNodeById(id);
            if (result) return result;
        }
        return null;
    }

    // static removeEventTypeNodeById(nodes: IEventTypeNode[], id: string): IEventTypeNode[] {
    //     if (!id || nodes.length < 1) return nodes;
    //     for (const node of nodes) {
    //         const result = node.getEventTypeNodeById(id);
    //         if (result) {
    //             if (result.parent) {
    //                 result.parent.children = result.parent.children.filter(i => i.id !== result.id);
    //                 return nodes.map(i => new EventTypeNode(i));
    //             } else {
    //                 return nodes.filter(i => i.id !== result.id).map(i => new EventTypeNode(i));
    //             }
    //         }
    //     }
    //     return nodes;
    // }
    
    getAsList(list: IRiskClassificationNode[]): IRiskClassificationNode[] {
        list.push(this);
        if (this.children.length < 1) return list;
        for (const child of this.children) {
            child.getAsList(list);
        }
        return list;
    }

    static getAsList(nodes: IRiskClassificationNode[]): IRiskClassificationNode[] {
        if (nodes.length < 1) return [];
        const result: IRiskClassificationNode[] = [];
        for (const node of nodes) {
            node.getAsList(result);
        }
        return result;
    }
    
    // getAsIdTitleNode(): IIdTitleNode {
    //     const result = IdTitleNode.createIdTitleNode(this.id, this.code, [], this.activeState > 0);
    //     for (const child of this.children) {
    //         result.children.push(child.getAsIdTitleNode());
    //     }
    //     return result;
    // }

    // static getAsIdTitleNodes(nodes: IEventTypeNode[]): IIdTitleNode[] {
    //     if (!nodes || nodes.length < 1) return [];
    //     const result: IIdTitleNode[] = [];
    //     for (const node of nodes) {
    //         result.push(node.getAsIdTitleNode());
    //     }
    //     return result;
    // }
}